import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import styles from './load-error.module.scss';
export const LoadError = ({
  onRetry
}: {
  onRetry: () => void;
}) => <Container className={styles.container} data-sentry-element="Container" data-sentry-component="LoadError" data-sentry-source-file="index.tsx">
    <div className={styles.content} role="alert">
      <SimpleImage src="error-icon.svg" width="137" height="137" alt="" data-sentry-element="SimpleImage" data-sentry-source-file="index.tsx" />
      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
        We couldn't load your subscription details
      </Title>
      <p className={styles.description}>
        Please try again. If the problem persists,{' '}
        <a href="mailto:support@mimika-app.com">contact our support team</a>.
      </p>
    </div>
    <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
      <UiKitButton onClick={onRetry} fullWidth data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
        Try Again
      </UiKitButton>
    </ButtonGroup>
  </Container>;